import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit wooden pergola on a 2x2 tile patch: 1.8 x 1.8 m and 2.3 m
// high — four oak posts, two cross beams along X and six slat boards
// running along Z across the top.
const OAK = "#c8975a";

const SPAN = 1.6; // post spacing (centres)
const POST_H = 2.1;
const BEAM_Y = 2.17;
const SLAT_Y = 2.28;

export const pergola = defineModel({
  id: "pergola",
  batchId: "modern",
  name: "Pergola",
  tags: ["modern", "outdoor", "garden", "pergola", "patio", "shade"],
  summary: "A wooden pergola with two beams and six top slats.",
  description:
    "A wooden pergola of the Modern Living kit on a 2x2 tile patch: 1.8 x " +
    "1.8 m and about 2.3 m high — four oak posts carrying two cross beams " +
    "along X and six slat boards along Z across the top.",
  tiles: { w: 2, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    const posts: Part[] = [];
    for (const x of [-SPAN / 2, SPAN / 2]) {
      for (const z of [-SPAN / 2, SPAN / 2]) {
        posts.push({
          geometry: new THREE.BoxGeometry(0.1, POST_H, 0.1),
          color: OAK,
          position: [x, POST_H / 2, z],
        });
      }
    }
    const slats: Part[] = [-0.75, -0.45, -0.15, 0.15, 0.45, 0.75].map((x) => ({
      geometry: new THREE.BoxGeometry(0.06, 0.06, 2.0),
      color: OAK,
      position: [x, SLAT_Y, 0],
    }));
    return [
      ...posts,
      // Two cross beams along X.
      {
        geometry: new THREE.BoxGeometry(2.0, 0.14, 0.1),
        color: OAK,
        position: [0, BEAM_Y, -SPAN / 2],
      },
      {
        geometry: new THREE.BoxGeometry(2.0, 0.14, 0.1),
        color: OAK,
        position: [0, BEAM_Y, SPAN / 2],
      },
      ...slats,
    ];
  },
  animations: [],
});
